import { EscapedString, html as svg } from '../c-mp/fun/html'
import {
	LABEL_BOTTOM,
	LABEL_TOP,
	LINE_RADIUS,
	PERSON_WIDTH,
} from './makeSvgTree'

export function drawConnector({
	content,
	x1,
	x2,
	y1,
	y2,
	isDashed,
}: {
	content: (EscapedString | string)[]
	x1: number
	y1: number
	x2: number
	y2: number
	isDashed?: boolean
}) {
	x1 = x1 + PERSON_WIDTH / 2
	y1 = y1 + LABEL_BOTTOM
	x2 = x2 + PERSON_WIDTH / 2
	y2 = y2 + LABEL_TOP
	const xDir = x2 - x1 > 0 ? 1 : -1
	const xDiff = Math.abs(x2 - x1)
	const yDiff = Math.abs(y2 - y1)
	const yDir = y2 - y1 > 0 ? 1 : -1
	content.unshift(
		xDiff >= LINE_RADIUS * 2
			? svg`<path
					d="M ${x1},${y1}
						v ${(yDiff / 2 - LINE_RADIUS) * yDir}
						a ${LINE_RADIUS} ${LINE_RADIUS} 90 0 ${xDir > 0 ? 0 : 1} ${LINE_RADIUS * xDir} ${LINE_RADIUS}
						h ${(xDiff - LINE_RADIUS * 2) * xDir}
						a ${LINE_RADIUS} ${LINE_RADIUS} 90 0 ${xDir > 0 ? 1 : 0} ${LINE_RADIUS * xDir} ${LINE_RADIUS}
						v ${(yDiff / 2 - LINE_RADIUS) * yDir}
					"
					fill="none"
					stroke="black"
					stroke-dasharray="${isDashed ? `4 4` : ''}"
				/>`
			: svg`<path
					d="M ${x1},${y1}
						v ${(yDiff / 2 - LINE_RADIUS) * yDir}
						c 0,${LINE_RADIUS * yDir} ${xDiff * xDir},${LINE_RADIUS * yDir} ${xDiff * xDir},${LINE_RADIUS * 2 * yDir}
						v ${(yDiff / 2 - LINE_RADIUS) * yDir}
					"
					fill="none"
					stroke="black"
					stroke-dasharray="${isDashed ? `4 4` : ''}"
				/>`,
	)
}
